"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFactContentContainerProperty = exports.factContentContainerPropertyDefinition = void 0;
exports.factContentContainerPropertyDefinition = {
    view: { label: 'Fact Container' },
    constraints: [
        {
            name: 'properties',
            argument: ['fact-content'],
        },
    ],
    type: 'container',
    multiple: true,
    name: 'fact-content-container',
};
const isFactContentContainerProperty = (prop) => {
    return prop.name === exports.factContentContainerPropertyDefinition.name;
};
exports.isFactContentContainerProperty = isFactContentContainerProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmFjdC1jb250ZW50LWNvbnRhaW5lci5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2ZhY3QtY29udGVudC1jb250YWluZXIucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxzQ0FBc0MsR0FBRztJQUNwRCxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsZ0JBQWdCLEVBQUU7SUFDakMsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsWUFBWTtZQUNsQixRQUFRLEVBQUUsQ0FBQyxjQUFjLENBQUM7U0FDM0I7S0FDRjtJQUNELElBQUksRUFBRSxXQUFXO0lBQ2pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLHdCQUF3QjtDQUNDLENBQUE7QUFJMUIsTUFBTSw4QkFBOEIsR0FBRyxDQUFDLElBQWtCLEVBQXdDLEVBQUU7SUFDekcsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLDhDQUFzQyxDQUFDLElBQUksQ0FBQTtBQUNsRSxDQUFDLENBQUE7QUFGWSxRQUFBLDhCQUE4QixrQ0FFMUMifQ==